/* eslint no-new: "off", class-methods-use-this: "off" */

import $ from "jquery";

class CustomValidation {
  /**
   * contains html form
   * @type {*|jQuery|HTMLElement}
   */
  $form;

  /**
   * contains all possible validators
   * identified on data attribute "data-validate"
   * @type {array}
   */
  validators = ["number", "alphabetic"];

  /**
   * load all validators
   * @method constructor
   */
  constructor(form) {
    this.$form = $(form);

    $.each(this.validators, (index, validator) => {
      const selector = `[data-validate=${validator}]`;
      // search all fields to validate
      const validateFields = this.$form.find(selector);

      // init each of them
      if (validateFields.length) {
        $.each(validateFields, (index2, field) => {
          if (validator === "number") {
            this.validateNumber(field);
          }
          if (validator === "alphabetic") {
            this.validateAlphabetic(field);
          }
        });
      }
    });
  }

  /**
   * allow only numbers and special key action e.g. copy, select all ...
   * @method validateNumber
   * @param formField
   */
  validateNumber(formField) {
    $(formField).keyup((e) => {
      const val = $(e.currentTarget).val();
      if (val.match(/[^0-9]/g)) {
        $(e.currentTarget).val(val.replace(/[^0-9]/g, ""));
      }
    });
  }

  /**
   * allow only alphabetic letters and special key action e.g. copy, select all ...
   * @method validateAlphabetic
   * @param formField
   */
  validateAlphabetic(formField) {
    $(formField).keyup((e) => {
      const val = $(e.currentTarget).val();
      if (val.match(/[^a-zA-Z]/g)) {
        $(e.currentTarget).val(val.replace(/[^a-zA-Z]/g, ""));
      }
    });
  }
}

(() => {
  new CustomValidation();
})();
